import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { DashboardUserManagementComponent } from './dashboard-user-management/dashboard-user-management.component';
import { DashboardUserAccessDetailComponent } from './dashboard-user-access-detail/dashboard-user-access-detail.component';
import { SharedUserAccessDetailDefaultComponent } from './shared-user-access-detail-default/shared-user-access-detail-default.component';
import { DashboardActiveIssuesManagementComponent } from './dashboard-active-issues-management/dashboard-active-issues-management.component';
import { DashboardActiveIssuesDetailComponent } from './dashboard-active-issues-detail/dashboard-active-issues-detail.component';
import { UserAccessDetailsDefaultComponent } from '../user-management/user-access-details-default/user-access-details-default.component';
import { DashboardActiveIssuesAccesspointDetailComponent } from './dashboard-active-issues-accesspoint-detail/dashboard-active-issues-accesspoint-detail/dashboard-active-issues-accesspoint-detail.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },

  {
    path: 'users',
    component: DashboardUserManagementComponent,
    children: [
      {
        path: '',
        component: UserAccessDetailsDefaultComponent,
      },
      {
        path: ':groupTypeName/:userGroupId',
        component: SharedUserAccessDetailDefaultComponent,
        data: { type: 'users' },
      },
      {
        path: ':groupTypeName/:userGroupId/:id',
        component: DashboardUserAccessDetailComponent,
      },
    ],
  },
  {
    path: 'active-issues',
    component: DashboardActiveIssuesManagementComponent,
    children: [
      {
        path: '',
        component: SharedUserAccessDetailDefaultComponent,
        data: { type: 'issues' },
      },
      {
        path: 'unit/:id/:buildingId/:unitId/:buildingName/:floorId',
        component: DashboardActiveIssuesDetailComponent,
      },
      {
        path: 'accesspoint/:id/:buildingId/:accessPointId/:buildingName/:floorId',
        component: DashboardActiveIssuesAccesspointDetailComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
